export const swapElementTag = (element, tagName) => {
  if (!element || !tagName) return element || null;

  const targetTag = tagName.toLowerCase();
  if (element.tagName.toLowerCase() === targetTag) return element;

  const replacement = document.createElement(targetTag);
  const blockedAttrs = new Set();
  if (targetTag === 'button') blockedAttrs.add('href');
  if (targetTag === 'a') blockedAttrs.add('type');

  Array.from(element.attributes).forEach(({ name, value }) => {
    if (blockedAttrs.has(name)) return;
    replacement.setAttribute(name, value);
  });

  if (targetTag === 'button' && !replacement.getAttribute('type')) {
    replacement.setAttribute('type', 'button');
  }

  while (element.firstChild) {
    replacement.appendChild(element.firstChild);
  }

  element.replaceWith(replacement);
  return replacement;
};
